module.exports = __webpack_public_path__ + "assets/img/guarantee2.5edd94f1.png";